var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useState, useEffect, useContext, useRef, Fragment } from "react";
import styled, { ThemeProvider, ThemeContext } from "styled-components";
import { Panel, Typography, Button, useScrollEvent } from "../../index";
import { HamburgerToggleIcon } from "./components/HamburgerToggleIcon";
import { LogoCtaToggle } from "./components/LogoCtaToggle";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { MenuLinksMobile } from "./components/MenuLinksMobile";

export var MobileMenu = function MobileMenu(_ref) {
  var ctaToggle = _ref.ctaToggle,
      startTransparent = _ref.startTransparent,
      hideCTA = _ref.hideCTA,
      menuContent = _ref.menuContent,
      wrapLink = _ref.wrapLink,
      wrapLinkLogo = _ref.wrapLinkLogo,
      logoVariant = _ref.logoVariant,
      currentPathname = _ref.currentPathname,
      pushdownNotification = _ref.pushdownNotification;

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var theme = useContext(ThemeContext);

  var _useScrollEvent = useScrollEvent({ offset: 20 }),
      navAtTop = _useScrollEvent.toggle;

  var ref = useRef(null);
  var PushdownNotification = pushdownNotification;

  useEffect(function () {
    if (open) {
      disableBodyScroll(ref.current);
      document.body.classList.add("nprogress_menu");
    } else {
      enableBodyScroll(ref.current);
      document.body.classList.remove("nprogress_menu");
    }
  }, [open]);

  // if (!ctaToggle) navAtTop = false;

  return React.createElement(
    Fragment,
    null,
    pushdownNotification && React.createElement(
      "div",
      { style: { opacity: 0 } },
      React.createElement(PushdownNotification, null)
    ),
    React.createElement(
      NavBar,
      {
        className: navAtTop && "navAtTop",
        startTransparent: startTransparent
      },
      React.createElement(PushdownNotification, null),
      React.createElement(
        NavContent,
        null,
        React.createElement(LogoCtaToggle, {
          menuContent: menuContent,
          wrapLink: wrapLink,
          wrapLinkLogo: wrapLinkLogo,
          logoVariant: logoVariant
        }),
        React.createElement(
          HamburgerContainer,
          {
            className: open && "open",
            onClick: function onClick() {
              return setOpen(!open);
            }
          },
          React.createElement(HamburgerToggleIcon, {
            toggle: open,
            inverted: navAtTop && startTransparent
          })
        ),
        React.createElement(
          ThemeProvider,
          {
            theme: _extends({}, theme.altThemes.inverted)
          },
          React.createElement(
            MenuSplash,
            { className: open && "open", ref: ref },
            React.createElement(
              Panel,
              {
                mt: 8
                // onClick={() => setOpen(false)}
              },
              React.createElement(MenuLinksMobile, {
                menuContent: menuContent,
                wrapLink: wrapLink,
                currentPathname: currentPathname,
                setOpen: setOpen
              })
            ),
            React.createElement("div", { style: { flex: 1 } }),
            React.createElement(
              Panel,
              { mb: 3.5, style: { padding: "0 1rem" } },
              menuContent.mainCtaElementMobile ? menuContent.mainCtaElementMobile : React.createElement(
                Button,
                {
                  fluid: true,
                  onClick: function onClick() {
                    setOpen(false);
                    menuContent.mainCtaAction();
                  }
                },
                menuContent.mainCta
              )
            )
          )
        )
      )
    )
  );
};

var transNavSticky = "200ms cubic-bezier(0.14, 0.98, 0.3, 1.11)";
var transOpenMenuTime = "400ms";
var transOpenMenuEasing = "cubic-bezier(0.14, 0.98, 0.3, 1.11)";

var NavBar = styled.nav.withConfig({
  displayName: "MobileMenu__NavBar",
  componentId: "xmi7hb-0"
})(["position:fixed;z-index:900;top:0;left:0;right:0;width:100%;background-color:", ";box-shadow:0 0 15px 0 rgba(0,0,0,0.11);&.navAtTop{background-color:", ";box-shadow:0 0 15px 0 rgba(0,0,0,0);}transition:box-shadow ", ",background-color ", ";will-change:box-shadow;"], function (props) {
  return props.theme.navBg;
}, function (props) {
  return props.startTransparent ? "inherit" : props.theme.background;
}, transNavSticky, transNavSticky);

var NavContent = styled.div.withConfig({
  displayName: "MobileMenu__NavContent",
  componentId: "xmi7hb-1"
})(["display:flex;align-items:center;height:72px;"]);

var HamburgerContainer = styled.div.withConfig({
  displayName: "MobileMenu__HamburgerContainer",
  componentId: "xmi7hb-2"
})(["position:relative;height:72px;width:72px;z-index:11;display:flex;justify-content:center;align-items:center;transition:color ", " linear;&.open{color:", ";}"], transOpenMenuTime, function (props) {
  return props.theme.colors.coreWhite;
});

var MenuSplash = styled.div.withConfig({
  displayName: "MobileMenu__MenuSplash",
  componentId: "xmi7hb-3"
})(["position:fixed;z-index:10;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;background-color:", ";color:", ";transition:opacity ", " ", ",transform ", " ", ";opacity:0;transform:scale(1.03);visibility:hidden;&.open{opacity:1;transform:scale(1);visibility:visible;}"], function (props) {
  return props.theme.background;
}, function (props) {
  return props.theme.textStrong;
}, transOpenMenuTime, transOpenMenuEasing, transOpenMenuTime, transOpenMenuEasing);